import React, { useCallback, useEffect, useState } from 'react';
import { View, SafeAreaView, ScrollView } from 'react-native';
import { Text } from 'react-native-elements';
import { useDispatch, useSelector } from 'react-redux';

import {
  Advertisement,
  FullCategory,
  isAdvertisement,
  Tag,
  ThumbtackPro,
} from '../../../api/adserver';
//TODO: this has to be cleaned up.  This library should probably be providing the store, NOT be selecting from the parent store
import {
  ExploreCategoryType,
  fetchAdvertCategories,
  selectThumbtackCategories,
  selectCategories,
} from '../../../store/advertCategoriesSlice';
import ThumbtackCard from '../../components/ThumbtackItem';

import {
  fetchAdvertsList,
  selectCategoryAdvertsList,
  selectFeaturedList,
} from '../../../store/advertsSlice';
import { fetchGatedAdvertsList } from '../../../store/advertsGatedSlice';
import {
  clearCurrentQuery,
  showModal,
  hideModal,
} from '../../../store/appSlice';
import { RootState } from '../../../store/rootReducer';

import { FullThumbtackCategory, Provider } from '../../../api/adserver';

import {
  SearchBar,
  ZoneCarousel,
  ZoneCategoryList,
  Divider,
} from '../../components';
import { DisplayType } from '../../components/zonecarousel';
import { SearchResult, SearchItemType } from '../../components/searchbar/types';
import styles from './styles';
import { ModalName } from '../../../components/RootOverlays';
import { AdvertCategory } from '../../types';

const debug = require('debug')('se:explore-screen-native');

interface ExploreScreenProps {
  corpName: string;
  onFindMoreClick: (
    item: FullCategory | FullThumbtackCategory,
    provider: Provider,
    thumbtackCategoryTapped?: string,
  ) => void;
  onCategoryClick: (item: FullCategory) => void;
  onTagClick: (title: string, tag: Tag) => void;
  onSearchResultClick: (query: string) => void;
  renderPromotedBanner?: () => React.ReactNode;
}

const ExploreScreen = ({
  corpName,
  onFindMoreClick,
  onCategoryClick,
  onTagClick,
  onSearchResultClick,
  renderPromotedBanner,
}: ExploreScreenProps) => {
  const { categories, advertCategories } = useSelector((state) =>
    selectCategories(state as RootState),
  );

  const { advertsList, categoryAdvertList } = useSelector((state) =>
    selectCategoryAdvertsList(state as RootState),
  );

  const { thumbtackCategory } = useSelector((state) =>
    selectThumbtackCategories(state as RootState),
  );

  const [hasSearchResults, setHasSearchResults] = useState(false);
  const [filteredAdvertCategories, setFilteredAdvertCategories] =
    useState(advertCategories);

  useEffect(() => {
    const newAdvertCategories = advertCategories.filter((category) => {
      if (category.category_type !== ExploreCategoryType.ExploreInternal) {
        return true;
      }
      if (category.age_gated_min_age) {
        return true;
      }
      const existingCategory = categoryAdvertList.find((catAdList) => {
        if (category.title === catAdList.title) {
          return true;
        }
        return false;
      });
      if (existingCategory) {
        return true;
      }
      return false;
    });
    setFilteredAdvertCategories(newAdvertCategories);
  }, [advertCategories, categoryAdvertList]);

  const findAdvert = useCallback(
    (item: SearchResult) => {
      const advert = advertsList.find(
        (advertElement: any) => advertElement.id === item.id,
      );
      return advert;
    },
    [advertsList],
  );

  const dispatch = useDispatch();

  const {
    featuredList,
    isLoading: isLoadingFeaturedList,
    featuredCategory,
  } = useSelector((state) => selectFeaturedList(state as RootState));

  useEffect(() => {
    /*global AbortController*/
    const abortController = new AbortController();

    try {
      if (!abortController.signal.aborted) {
        if (corpName) {
          dispatch(fetchAdvertCategories(corpName));
          dispatch(fetchAdvertsList(corpName));
          dispatch(fetchGatedAdvertsList(corpName));
          dispatch(clearCurrentQuery());
        }
      }
    } catch (e) {
      if (!abortController.signal.aborted) {
        console.error('abort signalled');
      }
    }
    return () => {
      abortController.abort();
    };
  }, [corpName, dispatch]);

  const toggleOverlay = () => {
    dispatch(hideModal());
  };

  const onPress = (
    item: Advertisement | ThumbtackPro,
    category?: FullCategory,
  ) => {
    // ignore thumbtack
    if (isAdvertisement(item)) {
      dispatch(
        showModal({
          modalName: ModalName.Advert,
          modalProps: {
            item,
            onClose: handleOnClose,
            onPressTag: handleOnPressTag,
          },
          isShowModal: true,
        }),
      );
    }
  };

  const onPressFindMore = (
    item: FullCategory | FullThumbtackCategory,
    provider: Provider = Provider.Zonetail,
    thumbtackCategoryTapped?: string,
  ) => {
    // debug('onPressFindMore was pressed', item.id);
    // navigation.navigate(RouteNames.Results, { query: item.title });
    onFindMoreClick(item, provider, thumbtackCategoryTapped);
  };

  const handleOnClose = () => {
    debug('item advert was closed');
    toggleOverlay();
  };

  const onPressCategory = (item: any) => {
    if (
      item.category_type === Provider.Thumbtack &&
      thumbtackCategory?.adverts
    ) {
      onPressFindMore(thumbtackCategory, Provider.ThumbtackCategory);
    } else {
      onCategoryClick(item);
    }
    // debug('onPressCategory was pressed', item.id);
    // navigation.navigate(RouteNames.Results, { query: item.title, age: item.age_gated_min_age });
  };

  const handleOnPressTag = (tag: Tag) => {
    handleOnClose();
  };

  const onSearchResultPress = (item: SearchResult) => {
    if (item.itemType === SearchItemType.category) {
      // TODO: callback here
      // navigation.navigate(RouteNames.Results, { query: item.title });
      onSearchResultClick(item.title);
    } else if (item.itemType === SearchItemType.advert) {
      const advert = findAdvert(item);
      if (advert) {
        onPress(advert);
      }
    }
  };

  const onSearchHasResults = (hasResults: boolean) => {
    setHasSearchResults(hasResults);
  };

  const onSearchUpdate = (value: string) => {
    debug(`explorelib: searchupdate for: ${value}`);
  };

  const getAdvertCategoryForIndex = (index: number) => {
    if (categories.length <= index) {
      return null;
    }
    if (
      categories[index].category_type &&
      categories[index].category_type === ExploreCategoryType.Thumbtack
    ) {
      return thumbtackCategory;
    }
    const thumbtackIndex = categories.findIndex(
      (category: AdvertCategory) =>
        category.category_type === ExploreCategoryType.Thumbtack,
    );
    let offset = 0;
    if (thumbtackIndex < index) {
      offset = 1;
    }
    return categoryAdvertList[index - offset];
  };

  const renderThumbtackItem = (item: any) => {
    if (thumbtackCategory) {
      return (
        <ThumbtackCard
          item={item}
          onPress={onPressFindMore}
          onPressFindMore={onPressFindMore}
          thumbtackData={thumbtackCategory}
        />
      );
    }
    return null;
  };

  const renderItemForIndex = (
    index: number,
  ): ((item: any) => JSX.Element | null) | null => {
    if (categories.length <= index) {
      return null;
    }
    if (categories[index].category_type === ExploreCategoryType.Thumbtack) {
      return renderThumbtackItem;
    }
    return null;
  };

  // useEffect(() => {
  //   const abortController = new AbortController();

  //   async function loadThumbtackData(building: string) {
  //     const filteredThumbCategory = await getFullThumbtackCategory(
  //       building,
  //       getZipcode(),
  //     );
  //     setThumbtackCategory(filteredThumbCategory);
  //   }

  //   try {
  //     if (!abortController.signal.aborted) {
  //       // handle success
  //       loadThumbtackData(corpName);
  //     }
  //   } catch (e) {
  //     if (!abortController.signal.aborted) {
  //       // handle error
  //     }
  //   }
  //   return () => {
  //     // clean up stuff
  //     abortController.abort();
  //   };
  // }, [corpName]);

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.searchWrapper}>
        <SearchBar
          placeholder="Search"
          sourceCategories={categories}
          sourceAdvertsList={advertsList}
          onInputUpdate={onSearchUpdate}
          onResultPress={onSearchResultPress}
          onHasResults={onSearchHasResults}
        />
      </View>
      {!hasSearchResults && (
        <ScrollView
          contentContainerStyle={styles.scrollContainer}
          contentInsetAdjustmentBehavior="automatic"
          style={[styles.scrollView]}
        >
          {renderPromotedBanner ? renderPromotedBanner() : null}
          <View
            style={[
              styles.contentContainer,
              styles.featuredItemsContainer,
              styles.sectionEnd,
              styles.noFlex,
            ]}
          >
            <View style={(styles.featureHeadingContainer, styles.sectionStart)}>
              <Text style={styles.featureHeading}>Featured</Text>
            </View>
            <ZoneCarousel
              loop
              name="landingfeatured"
              displayType={DisplayType.featured}
              onPress={(item: Advertisement) =>
                featuredCategory && onPress(item, featuredCategory)
              }
              onPressCategory={onPressFindMore}
              items={featuredList}
              showViewMore={false}
            />
          </View>
          <Divider />
          <View
            style={[
              styles.contentContainer,
              styles.noFlex,
              styles.advertCategoryList,
            ]}
          >
            <ZoneCarousel
              name="landingcategories"
              displayType={DisplayType.mini}
              items={filteredAdvertCategories}
              onPressData={onPressCategory}
            />
          </View>
          <Divider />
          <View style={[styles.contentContainer, styles.noFlex]}>
            <ZoneCategoryList
              advertCategoryForIndex={getAdvertCategoryForIndex}
              categoryCount={
                categoryAdvertList.length + (thumbtackCategory ? 1 : 0)
              }
              renderItemForIndex={renderItemForIndex}
              onPress={onPress}
              onPressCategory={onPressFindMore}
            />
          </View>
        </ScrollView>
      )}
    </SafeAreaView>
  );
};

export default React.memo(ExploreScreen);
